import { type FC } from "react";
import { Text } from "@/components/podkit/typography/Text";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { agentExecutionState, AgentExecutionState } from "@/utils/agent-executions";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";

type AgentExecutionStatusLabelProps = {
    agentExecution: PlainAgentExecution;
} & PropsWithClassName;

export const AgentExecutionStatusLabel: FC<AgentExecutionStatusLabelProps> = ({ agentExecution, className }) => {
    const state = agentExecutionState(agentExecution);
    if (!state) {
        return null;
    }

    const isWorking = state === AgentExecutionState.WORKING;

    return (
        <Text className={cn("text-sm text-content-secondary", className)} asChild>
            <span>
                {state}
                {isWorking && <span className="animate-dots">.</span>}
            </span>
        </Text>
    );
};
